import { useState, useRef, useEffect } from "react";
import img1 from "./screenshots/1.jpg";
import img2 from "./screenshots/2.jpg";
import img3 from "./screenshots/3.jpg";
import img4 from "./screenshots/4.jpg";
import APP_ICON from "./screenshots/icon.png";
import { fetchAppUrl } from "../../../axios"; 

const screenshots = [img1, img2, img3, img4];

const FALLBACK_URL =
  "https://github.com/zadengi07/DevCore-APPS/releases/download/2.23.34/DevCore.apk";

export default function DownloadApp() {
  const [downloadUrl, setDownloadUrl] = useState(FALLBACK_URL);
  const [downloading, setDownloading] = useState(false);
  const [previewImg, setPreviewImg] = useState(null);
  const scrollRef = useRef(null);

  useEffect(() => {
    fetchAppUrl().then((url) => {
      if (url) setDownloadUrl(url);
    });
  }, []);

  const handleDownload = () => {
    setDownloading(true);
    setTimeout(() => setDownloading(false), 2500);
  };

  const scroll = (dir) => {
    scrollRef.current?.scrollBy({ left: dir * 260, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-5 py-8">

        <div className="flex gap-5 items-start mb-6">
          <div className="w-24 h-24 rounded-[22px] overflow-hidden shrink-0 shadow-md shadow-stone-200 border border-stone-100">
            <img
              src={APP_ICON}
              alt="DevCore ikonkasi"
              className="w-full h-full object-cover"
              onError={(e) => {
                e.currentTarget.style.display = "none";
                e.currentTarget.parentElement.classList.add(
                  "bg-[#7C3AED]",
                  "flex",
                  "items-center",
                  "justify-center"
                );
              }}
            />
          </div>

          <div className="flex-1 min-w-0">
            <h1 className="text-[22px] font-bold text-stone-900 leading-tight mb-0.5">
              DevCore Mobile
            </h1>
            <p className="text-[13px] text-[#7C3AED] font-medium mb-2">
              https://dev-core.uz
            </p>

            <div className="flex items-center gap-4 text-[12px] text-stone-500 mb-3">
              <div className="flex items-center gap-1">
                <span className="font-semibold text-stone-800">4.9</span>
                <span className="text-amber-500">★</span>
              </div>
              <div className="w-px h-3 bg-stone-300" />
              <span>500+ o'rnatish</span>
              <div className="w-px h-3 bg-stone-300" />
              <span className="uppercase">3+</span>
            </div>
          </div>
        </div>

        {/* Yuklab olish tugmasi — to'liq kenglikda, Play Market kabi */}
        <a
          href={downloadUrl}
          onClick={handleDownload}
          download
          className="w-full flex items-center justify-center gap-2 bg-[#7C3AED] hover:bg-[#6D28D9] transition text-white font-semibold text-[15px] py-3.5 rounded-full shadow-md shadow-purple-500/20 mb-2"
        >
          {downloading ? (
            <>
              <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />
              Yuklanmoqda...
            </>
          ) : (
            "O'rnatish"
          )}
        </a>
        <p className="text-center text-stone-400 text-[11.5px] mb-8">
          ~108 MB · Android 8.0+
        </p>

        {/* ===== OGOHLANTIRISH ===== */}
        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4 mb-8 flex gap-3 items-start">
          <span className="text-xl leading-none">⚠️</span>
          <p className="text-amber-700/90 text-[13px] leading-relaxed">
            Bu ilova faqat <b>DevCore</b> o'quv tizimi talabalari uchun
            mo'ljallangan. Ilovani o'rnatgandan so'ng, mentoringiz bergan{" "}
            <b>ID</b> orqali tizimga kirasiz. Aks holda ilova sizda umuman
            ishlamaydi.
          </p>
        </div>

        {/* ===== SCREENSHOTLAR ===== */}
        <div className="relative mb-10">
          <h2 className="text-[13px] font-semibold text-stone-500 mb-3 tracking-wide">
            SKRINSHOTLAR
          </h2>

          <div
            ref={scrollRef}
            className="flex gap-3 overflow-x-auto scroll-smooth pb-2 -mx-1 px-1"
            style={{ scrollbarWidth: "none" }}
          >
            {screenshots.map((src, i) => (
              <button
                key={i}
                onClick={() => setPreviewImg(src)}
                className="shrink-0 rounded-2xl overflow-hidden border border-stone-200 h-[380px] hover:opacity-90 transition"
              >
                <img
                  src={src}
                  alt={`Skrinshot ${i + 1}`}
                  className="h-full w-auto object-cover"
                />
              </button>
            ))}
          </div>

          <button
            onClick={() => scroll(-1)}
            className="hidden md:flex absolute -left-4 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white border border-stone-200 shadow items-center justify-center text-stone-500 hover:text-stone-800"
          >
            ‹
          </button>
          <button
            onClick={() => scroll(1)}
            className="hidden md:flex absolute -right-4 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white border border-stone-200 shadow items-center justify-center text-stone-500 hover:text-stone-800"
          >
            ›
          </button>
        </div>

        {/* ===== TAVSIF ===== */}
        <div className="mb-10">
          <h2 className="text-[15px] font-bold text-stone-800 mb-2">
            Ilova haqida
          </h2>
          <p className="text-[13.5px] text-stone-600 leading-relaxed">
            DevCore — dasturlash jamoasi talabalari uchun mo'ljallangan o'quv
            tizimi ilovasi. Ilova orqali darslar jadvali, ballar, davomat va
            reyting jadvalini kuzatib borishingiz mumkin.
          </p>
        </div>

        {/* ===== PASTKI YUKLAB OLISH ===== */}
        <a
          href={downloadUrl}
          onClick={handleDownload}
          download
          className="w-full flex items-center justify-center gap-2 bg-[#7C3AED] hover:bg-[#6D28D9] transition text-white font-semibold text-[15px] py-3.5 rounded-full shadow-md shadow-purple-500/20"
        >
          O'rnatish
        </a>
      </div>

      {/* ===== RASM TO'LIQ EKRAN PREVIEW ===== */}
      {previewImg && (
        <div
          onClick={() => setPreviewImg(null)}
          className="fixed inset-0 bg-black/85 z-50 flex items-center justify-center p-6 cursor-zoom-out"
        >
          <img
            src={previewImg}
            alt="Kattalashtirilgan skrinshot"
            className="max-h-full max-w-full rounded-2xl object-contain"
          />
        </div>
      )}
    </div>
  );
}